var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.914062,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#EAE6FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3550_31429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 44.9141C30.35 44.9141 29 43.5641 29 41.9141V23.9141C29 22.2641 30.35 20.9141 32 20.9141C33.65 20.9141 35 22.2641 35 23.9141V41.9141C35 43.5641 33.65 44.9141 32 44.9141ZM41 44.9141C39.35 44.9141 38 43.5641 38 41.9141V29.9141C38 28.2641 39.35 26.9141 41 26.9141C42.65 26.9141 44 28.2641 44 29.9141V41.9141C44 43.5641 42.65 44.9141 41 44.9141ZM23 44.9141C21.35 44.9141 20 43.5641 20 41.9141V35.9141C20 34.2641 21.35 32.9141 23 32.9141C24.65 32.9141 26 34.2641 26 35.9141V41.9141C26 43.5641 24.65 44.9141 23 44.9141Z",
    fill: "#6F4EF6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3550_31429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(20 20.9141)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon (3).45ffd3831e7cd72d887dbd178f144a9f.svg";
export { ForwardRef as ReactComponent };